/** 서버 오류 봉투 `{error:{code,message}}` (csms-api app/common/errors.py). */
type ErrorEnvelope = { response?: { data?: { error?: { code?: string; message?: string; detail?: unknown } } } };

/** axios 오류에서 서버 메시지를 뽑는다. 없으면 기본 문구. */
export function apiErrorMessage(e: unknown, fallback = "처리하지 못했습니다"): string {
  return (e as ErrorEnvelope)?.response?.data?.error?.message || fallback;
}

/** axios 오류에서 서버 오류 코드(`LAST_ADMIN` 등)를 뽑는다. 봉투가 아니면 undefined. */
export function apiErrorCode(e: unknown): string | undefined {
  return (e as ErrorEnvelope)?.response?.data?.error?.code;
}

/** 오류 봉투의 detail(서버가 덧붙인 구조화 정보). 없으면 undefined. */
export function apiErrorDetail<T = Record<string, unknown>>(e: unknown): T | undefined {
  return (e as ErrorEnvelope)?.response?.data?.error?.detail as T | undefined;
}
